module.exports = __webpack_public_path__ + "img/icon-25.c08eb5ef.svg";